/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_Rules_TitleInputs */

const en_us2_exercise_personal_info_rules_title = /** @type {(inputs: Exercise_Personal_Info_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What counts`)
};

const pt_br2_exercise_personal_info_rules_title = /** @type {(inputs: Exercise_Personal_Info_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que entra na conta`)
};

const es_419_exercise_personal_info_rules_title = /** @type {(inputs: Exercise_Personal_Info_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué cuenta`)
};

const pt_pt2_exercise_personal_info_rules_title = /** @type {(inputs: Exercise_Personal_Info_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que entra na conta`)
};

const fr_fr2_exercise_personal_info_rules_title = /** @type {(inputs: Exercise_Personal_Info_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qui compte`)
};

const de_de2_exercise_personal_info_rules_title = /** @type {(inputs: Exercise_Personal_Info_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was zählt`)
};

const it_it2_exercise_personal_info_rules_title = /** @type {(inputs: Exercise_Personal_Info_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa conta`)
};

/**
* | output |
* | --- |
* | "What counts" |
*
* @param {Exercise_Personal_Info_Rules_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_rules_title = /** @type {((inputs?: Exercise_Personal_Info_Rules_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_Rules_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_rules_title(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_rules_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_rules_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_rules_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_rules_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_rules_title(inputs)
	return en_us2_exercise_personal_info_rules_title(inputs)
});
export { exercise_personal_info_rules_title as "exercise-personal.info_rules_title" }